/**
 * CSRFトークンを取得するためのユーティリティ関数
 */

/**
 * ドキュメントからCSRFトークンを取得する
 * Django CSRFトークンはcookieに保存されている、またはmetaタグに格納されている場合がある
 */
export const getCsrfToken = (): string => {
  // 1. metaタグからCSRFトークンを取得
  const csrfTokenElement = document.querySelector('meta[name="csrf-token"]');
  if (csrfTokenElement && csrfTokenElement.getAttribute('content')) {
    return csrfTokenElement.getAttribute('content') || '';
  }

  // 2. cookieからCSRFトークンを取得
  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === 'csrftoken') {
      return value;
    }
  }
  
  // Djangoの場合、csrftokenという名前でcookieに保存されている
  console.warn('CSRFトークンが見つかりませんでした');
  return '';
}; 